import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import type { SalesReservationFilters } from '@/features/sales-reservations/api'
import { ReservationList } from '@/features/sales-reservations/reservation-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the reservations list (plan screen 5). Gated on
 * `stock.view` — Inventory's own gate on `GET /sales/reservations`
 * (`catalog-sales.ts`'s own comment) — not a Sales permission.
 */
export const Route = createFileRoute('/_authenticated/sales/reservations')({
  validateSearch: (search: Record<string, unknown>): SalesReservationFilters => ({
    variantId:
      typeof search.variantId === 'string' && search.variantId ? search.variantId : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: SalesReservationsRoute,
})

function SalesReservationsRoute() {
  const navigate = useNavigate()
  const params = Route.useSearch()

  return (
    <ReservationList
      params={params}
      onParamsChange={(next) => void navigate({ to: '/sales/reservations', search: next })}
    />
  )
}
